<template>
    <div v-if="activeLocation === title">
        <h2 class="text-3xl mb-4 text-orange" v-text="title"></h2>
        <div class="font-serif text-xl leading-tight text-gray-900" v-if="address.address1" v-text="address.address1"></div>
        <div class="font-serif text-xl leading-tight text-gray-900" v-if="address.address2" v-text="address.address2"></div>
        <div class="font-serif text-xl leading-tight text-gray-900" v-if="address.address3" v-text="address.address3"></div>
        <div class="font-serif text-xl leading-tight text-gray-900" v-if="address.city" v-text="address.city"></div>
        <div class="font-serif text-xl leading-tight text-gray-900" v-if="address.county" v-text="address.county"></div>
        <div class="font-serif text-xl leading-tight text-gray-900" v-if="address.country" v-text="address.country"></div>
        <div class="font-serif text-xl leading-tight text-gray-900" v-if="address.postcode" v-text="address.postcode"></div>
        <div class="uppercase text-xl leading-tight text-gray-900 mt-4 font-serif" v-if="address.tel"><span class='text-orange'>T:</span> <span v-text="address.tel"></span></div>
        <a class="text-xl text-orange" v-if="address.email" :href="`mailto:` + address.email" v-text="address.email"></a>
    </div>
</template>

<script>
    import {MAP} from "@/store/types/modules";
    import {mapState} from 'vuex'

    export default {
        props: {
            title: String,
            address: Object,
            backgroundUrl: String
        },
        computed: {
            ...mapState(MAP, {
                activeLocation: 'activeLocation'
            })
        }
    }
</script>